export default __webpack_public_path__ + "static/media/home1.d561845c.jpg";